import { LockFailureReasons } from '@/accessControl/LockFailureReasons.atom';
import type { LockErrorOutputV1 } from '@seeqdev/api/model/LockErrorOutputV1';

/**
 * The Lock tab's plain list of blocking items: every item with its own failure reasons underneath, no grouping
 * chrome. Used both when nothing grouped at all and as the fallback inside a workbook group whose errors failed for
 * differing reasons.
 */
export const LockErrorList = ({ errors, isVantage }: { errors: LockErrorOutputV1[]; isVantage: boolean }) => (
  <>
    {errors.map((globalItem) => (
      <div key={`error-container-${globalItem.item.id}`} className="tw:mb-5">
        <LockFailureReasons itemName={globalItem.item.name} globalItem={globalItem} isVantage={isVantage} />
      </div>
    ))}
  </>
);
